import { Token } from '@/domain/types/Token'
import { PageLayout } from '@/ui/layouts/PageLayout'
import { cn } from '@/ui/utils/style'
import { TradePanel } from '../components/TradePanel'

interface SwapViewProps {
  withHeading?: boolean
  simplified?: boolean
  isModal?: boolean
  isSwapPage?: boolean
  token?: Token
  lockToToken?: boolean
  stackedSuccessScreen?: boolean
}

export function SwapView({
  withHeading,
  simplified,
  isModal,
  isSwapPage,
  token,
  lockToToken,
  stackedSuccessScreen,
}: SwapViewProps) {
  if (simplified) {
    return (
      <TradePanel
        isModal={isModal}
        withHeading={withHeading}
        simplified
        isSwapPage={isSwapPage}
        token={token}
        lockToToken={lockToToken}
        stackedSuccessScreen={stackedSuccessScreen}
      />
    )
  }

  return (
    <PageLayout className={cn(withHeading ? 'mt-8' : 'p-0')}>
      <div className="flex justify-center">
        <TradePanel
          isModal={isModal}
          withHeading={withHeading}
          isSwapPage={isSwapPage}
          token={token}
          lockToToken={lockToToken}
          stackedSuccessScreen={stackedSuccessScreen}
        />
      </div>
    </PageLayout>
  )
}
